import { render, staticRenderFns } from "./GenericSignupForm.vue?vue&type=template&id=71ef355c&scoped=true&"
import script from "./GenericSignupForm.vue?vue&type=script&lang=js&"
export * from "./GenericSignupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef355c",
  null
  
)

export default component.exports